import React, { useState } from "react";

const FAQPage = () => {
  const [faqs] = useState([
    {
      id: 1,
      question: "What is the return policy?",
      answer:
        "We offer a 30-day return policy for all new items in their original condition. Items must be unworn and in the original packaging. Pre-owned items are not eligible for return.",
    },
    {
      id: 2,
      question: "How long does shipping take?",
      answer:
        "Shipping typically takes 5-7 business days.",
    },
    {
      id: 3,
      question: "What is your re-icing service?",
      answer:
        "Our re-icing service restores yellowed and oxidized translucent soles on classic or modern sneakers.",
    },
    {
      id: 4,
      question: "How long does the re-icing service take?",
      answer:
        "Customers typically receive their shoes back within 1-2 weeks from the day we receive them. This also depends on the condition of the shoes, number of sessions purchased, and our current workload.",
    },
    {
      id: 5,
      question: "How can I track my order?",
      answer:
        "Once your order ships, you'll receive a tracking number via email. You can use this to monitor your package in real-time.",
    },
  ]);

  const [expandedId, setExpandedId] = useState(null);

  const toggleFAQ = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="bg-white rounded-3xl shadow-xl p-4 sm:p-6 lg:p-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-2 sm:mb-4 leading-tight">
          Frequently Asked Questions
        </h1>
        <p className="text-base sm:text-lg text-gray-700">
          Find answers to common questions about our products and services.
        </p>
      </div>

      <div className="max-w-3xl mx-auto space-y-3 sm:space-y-4">
        {faqs.map((faq) => (
          <div
            key={faq.id}
            className="border border-gray-300 rounded-2xl overflow-hidden bg-white shadow-md transition hover:shadow-lg"
          >
            <button
              onClick={() => toggleFAQ(faq.id)}
              className="w-full px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between bg-gray-50 hover:bg-gray-100 transition"
            >
              <h3 className="text-base sm:text-lg font-bold text-gray-900 text-left">
                {faq.question}
              </h3>
              <svg
                className={`w-5 h-5 sm:w-6 sm:h-6 text-indigo-600 transition-transform flex-shrink-0 ml-4`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                style={{
                  transform:
                    expandedId === faq.id ? "rotate(180deg)" : "rotate(0deg)",
                }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 14l-7 7m0 0l-7-7m7 7V3"
                />
              </svg>
            </button>

            {expandedId === faq.id && (
              <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-300">
                <p className="text-sm sm:text-base text-gray-700">
                  {faq.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQPage;